import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { resetCheck } from '../checked/actions';
import { resetTournaments } from '../tournaments/actions';

import { change, toggle } from './actions';

import style from './style.pcss';

const cx = classNames.bind(style);

@connect((state) => ({
    select: state.select
}))
class Select extends Component {

    static displayName = '[block] select';

    static propTypes = {
        values  : PropTypes.array,
        id      : PropTypes.string.isRequired,
        dispatch: PropTypes.func,
        select  : PropTypes.object,
        disabled: PropTypes.bool
    };

    state = {
        value: ''
    };

    toggleDropdown = (e) => {
        if(this.props.disabled) {
            return false
        }
        e.stopPropagation();
        this.props.dispatch(toggle(this.props.id));
        this.setState({
            value: e.currentTarget.innerText
        })
    };

    selected = (e) => {
        const { dispatch, id, select } = this.props;

        dispatch(change(id, e.currentTarget.innerHTML));

        if(id === 'special') {
            if(e.currentTarget.innerHTML === select[id].value) {
                return false;
            }

            dispatch(resetCheck());
            dispatch(resetTournaments());
        }
    };

    render() {
        return (
            <div
                className={cx('select', {
                    // eslint-disable-next-line camelcase
                    select_open    : this.props.select[this.props.id].show,
                    // eslint-disable-next-line camelcase
                    select_disabled: this.props.disabled
                })}
                onClick={this.toggleDropdown}
            >
                <span className={style['select__value']}>{this.props.select[this.props.id].value}</span>
                <span className={style['select__toggle']}>
                    <span className={style['caret']} />
                </span>
                <ul className={style['select__dropdown']}>
                    {this.props.values.map((item) => (
                        <li
                            className={cx('select__dropdown-item', { 'select__dropdown-item_selected': this.state.value === item.text })}
                            onClick={this.selected}
                            key={item.text}
                            data-count={item.count || 0}
                        >
                            {item.text}
                        </li>
                    ))}
                </ul>
            </div>
        )
    }

}

export default Select;



// WEBPACK FOOTER //
// ./src/blocks/select/index.js